export default __webpack_public_path__ + "static/media/Facebook.d80586dd.svg";